import { ValidationErrorData } from '../typings/common';
import { MetrikaCounterEditorValue } from '../typings/metrikaCounterEditor';

export const OPEN_METRIKA_COUNTER_EDITOR = 'OPEN_METRIKA_COUNTER_EDITOR';
export type OPEN_METRIKA_COUNTER_EDITOR = typeof OPEN_METRIKA_COUNTER_EDITOR;

export interface OpenMetrikaCounterEditorAction {
    type: OPEN_METRIKA_COUNTER_EDITOR;
    editorId: string;
    savedValue?: MetrikaCounterEditorValue;
}

export function openMetrikaCounterEditor(
    editorId: string,
    savedValue?: MetrikaCounterEditorValue
): OpenMetrikaCounterEditorAction {
    return {
        type: OPEN_METRIKA_COUNTER_EDITOR,
        editorId,
        savedValue
    };
}

export const CLOSE_METRIKA_COUNTER_EDITOR = 'CLOSE_METRIKA_COUNTER_EDITOR';
export type CLOSE_METRIKA_COUNTER_EDITOR = typeof CLOSE_METRIKA_COUNTER_EDITOR;

export interface CloseMetrikaCounterEditorAction {
    type: CLOSE_METRIKA_COUNTER_EDITOR;
    editorId: string;
}

export function closeMetrikaCounterEditor(
    editorId: string
): CloseMetrikaCounterEditorAction {
    return {
        type: CLOSE_METRIKA_COUNTER_EDITOR,
        editorId
    };
}

export const SELECT_COUNTER_METRIKA_COUNTER_EDITOR =
    'SELECT_COUNTER_METRIKA_COUNTER_EDITOR';
export type SELECT_COUNTER_METRIKA_COUNTER_EDITOR = typeof SELECT_COUNTER_METRIKA_COUNTER_EDITOR;

export interface SelectCounterMetrikaCounterEditorAction {
    type: SELECT_COUNTER_METRIKA_COUNTER_EDITOR;
    editorId: string;
    counter: string;
}

export function selectCounterMetrikaCounterEditor(
    editorId: string,
    counter: string
): SelectCounterMetrikaCounterEditorAction {
    return {
        type: SELECT_COUNTER_METRIKA_COUNTER_EDITOR,
        editorId,
        counter
    };
}

export const APPLY_COUNTERS_FROM_POPUP_METRIKA_COUNTER_EDITOR =
    'APPLY_COUNTERS_FROM_POPUP_METRIKA_COUNTER_EDITOR';
export type APPLY_COUNTERS_FROM_POPUP_METRIKA_COUNTER_EDITOR = typeof APPLY_COUNTERS_FROM_POPUP_METRIKA_COUNTER_EDITOR;

export interface ApplyCounterMetrikaCounterEditorAction {
    type: APPLY_COUNTERS_FROM_POPUP_METRIKA_COUNTER_EDITOR;
    editorId: string;
}

export function applyCountersMetrikaCounterEditor(
    editorId: string
): ApplyCounterMetrikaCounterEditorAction {
    return {
        type: APPLY_COUNTERS_FROM_POPUP_METRIKA_COUNTER_EDITOR,
        editorId
    };
}

export const CANCEL_COUNTERS_FROM_POPUP_METRIKA_COUNTER_EDITOR =
    'CANCEL_COUNTERS_FROM_POPUP_METRIKA_COUNTER_EDITOR';
export type CANCEL_COUNTERS_FROM_POPUP_METRIKA_COUNTER_EDITOR = typeof CANCEL_COUNTERS_FROM_POPUP_METRIKA_COUNTER_EDITOR;

export interface CancelCounterMetrikaCounterEditorAction {
    type: CANCEL_COUNTERS_FROM_POPUP_METRIKA_COUNTER_EDITOR;
    editorId: string;
}

export function cancelCountersMetrikaCounterEditor(
    editorId: string
): CancelCounterMetrikaCounterEditorAction {
    return {
        type: CANCEL_COUNTERS_FROM_POPUP_METRIKA_COUNTER_EDITOR,
        editorId
    };
}

export const CHANGE_MARK_LINKS_METRIKA_COUNTER_EDITOR =
    'CHANGE_MARK_LINKS_METRIKA_COUNTER_EDITOR';
export type CHANGE_MARK_LINKS_METRIKA_COUNTER_EDITOR = typeof CHANGE_MARK_LINKS_METRIKA_COUNTER_EDITOR;

export interface ChangeMarkLinksMetrikaCounterEditorAction {
    type: CHANGE_MARK_LINKS_METRIKA_COUNTER_EDITOR;
    editorId: string;
}

export function changeMarkLinksMetrikaCounterEditor(
    editorId: string
): ChangeMarkLinksMetrikaCounterEditorAction {
    return {
        type: CHANGE_MARK_LINKS_METRIKA_COUNTER_EDITOR,
        editorId
    };
}

export const FETCH_COUNTERS_METRIKA_COUNTER_EDITOR =
    'FETCH_COUNTERS_METRIKA_COUNTER_EDITOR';
export type FETCH_COUNTERS_METRIKA_COUNTER_EDITOR = typeof FETCH_COUNTERS_METRIKA_COUNTER_EDITOR;

export interface FetchCountersMetrikaCounterEditorAction {
    type: FETCH_COUNTERS_METRIKA_COUNTER_EDITOR;
}

export function fetchCountersMetrikaCounterEditor(): FetchCountersMetrikaCounterEditorAction {
    return {
        type: FETCH_COUNTERS_METRIKA_COUNTER_EDITOR
    };
}

export const UPDATE_COUNTERS_METRIKA_COUNTER_EDITOR =
    'UPDATE_COUNTERS_METRIKA_COUNTER_EDITOR';
export type UPDATE_COUNTERS_METRIKA_COUNTER_EDITOR = typeof UPDATE_COUNTERS_METRIKA_COUNTER_EDITOR;

export interface UpdateCountersMetrikaCounterEditorAction {
    type: UPDATE_COUNTERS_METRIKA_COUNTER_EDITOR;
    counters: string[];
}

export function updateCountersMetrikaCounterEditor(
    counters: string[]
): UpdateCountersMetrikaCounterEditorAction {
    return {
        type: UPDATE_COUNTERS_METRIKA_COUNTER_EDITOR,
        counters
    };
}

export const SET_METRIKA_UNAVAILABLE_FLAG_FOR_METRIKA_COUNTER_EDITOR =
    'SET_METRIKA_UNAVAILABLE_FLAG_FOR_METRIKA_COUNTER_EDITOR';
export type SET_METRIKA_UNAVAILABLE_FLAG_FOR_METRIKA_COUNTER_EDITOR = typeof SET_METRIKA_UNAVAILABLE_FLAG_FOR_METRIKA_COUNTER_EDITOR;

export interface SetMetrikaUnAvailableFlagForMetrikaCounterEditorAction {
    type: SET_METRIKA_UNAVAILABLE_FLAG_FOR_METRIKA_COUNTER_EDITOR;
    isAvailable: boolean;
}

export function setMetrikaUnAvailableFlagForMetrikaCounterEditor(
    isAvailable: boolean
): SetMetrikaUnAvailableFlagForMetrikaCounterEditorAction {
    return {
        type: SET_METRIKA_UNAVAILABLE_FLAG_FOR_METRIKA_COUNTER_EDITOR,
        isAvailable
    };
}

export const SHOW_METRIKA_COUNTER_EDITOR_ERRORS =
    'SHOW_METRIKA_COUNTER_EDITOR_ERRORS';
export type SHOW_METRIKA_COUNTER_EDITOR_ERRORS = typeof SHOW_METRIKA_COUNTER_EDITOR_ERRORS;

export interface ShowMetrikaCounterEditorErrorsAction {
    type: SHOW_METRIKA_COUNTER_EDITOR_ERRORS;
    editorId: string;
    errors?: ValidationErrorData[];
}

export function showMetrikaCounterEditorErrors(
    editorId: string,
    errors?: ValidationErrorData[]
): ShowMetrikaCounterEditorErrorsAction {
    return {
        type: SHOW_METRIKA_COUNTER_EDITOR_ERRORS,
        editorId,
        errors
    };
}

export type MetrikaCounterEditorAction =
    | OpenMetrikaCounterEditorAction
    | CloseMetrikaCounterEditorAction
    | SelectCounterMetrikaCounterEditorAction
    | ChangeMarkLinksMetrikaCounterEditorAction
    | FetchCountersMetrikaCounterEditorAction
    | UpdateCountersMetrikaCounterEditorAction
    | SetMetrikaUnAvailableFlagForMetrikaCounterEditorAction
    | ApplyCounterMetrikaCounterEditorAction
    | CancelCounterMetrikaCounterEditorAction
    | ShowMetrikaCounterEditorErrorsAction;
